/*
* Project: LegalPlace assistant
* File: src/components/buy/card_modal.js
* Author: Amine Azizi
* Version: 1.0
*/


import React, { Component } from 'react';
import { connect } from 'react-redux';
import MaskedInput from '../misc/masked_input';
import {
  ckPaymentSelect, ckCUpdateCardNumber, ckCUpdateCardExpiration, ckCUpdateCCV, ckCUpdateDirectName, ckCUpdateIban, CK_CHECK,
} from '../../redux/actions/checkout_operations';
import { store } from '../../globals';
import lpevents from '../../tracking/lpevents';
import { raiseError, unraiseError } from '../../errors/error';
import { checkingPayment } from '../../redux/actions/loading';
import { lpPattern, P_CLOSE_PAIMENT, P_PAY } from '../../tracking/pattern_detector';
import { _lp } from '../../logic/wording';
import lpApp from '../../app/lp_app';
import { setRepriseLink, setRepriseWizard } from '../../redux/actions/contract';
import { setX3Payment, setCardPayment, setPaypalPayment, setDirectPayment} from '../../redux/actions/account_settings';
import {stripe, stripeElement} from '../utils/stripe_element';
import {CUSTOM_CGV_LINK_PER_META_IDS} from '../../constants/hardcoded_checkout'

// intiialization of errors payment errors
function initErrors() {
  unraiseError('credit-error');
  unraiseError('credit.number');
  unraiseError('card.exp');
  unraiseError('card.cvc');
  unraiseError('card.number');
  unraiseError('direct.name');
  unraiseError('direct.iban');
  unraiseError('global');
}

const linkStyle = {
  cursor: 'pointer',
};

const divStyle = {
  none: {
    display: 'none',
  },
  block: {
    display: 'block',
  },
};



class _CardModalNext extends Component {
  constructor(props) {
    super(props);
    this.updateCardNumber = this.updateCardNumber.bind(this);
    this.updateCardExpiration = this.updateCardExpiration.bind(this);
    this.updateCardCCV = this.updateCardCCV.bind(this);
    this.updateName = this.updateName.bind(this);
    // this.updateIban = this.updateIban.bind(this);
    this.initiatePayment = this.initiatePayment.bind(this);
    this.updateCheckBox = this.updateCheckBox.bind(this);
    this.totalPriceTTC = this.totalPriceTTC.bind(this);
    this.choosePaymentMode = this.choosePaymentMode.bind(this);
    this.iban = stripeElement();

    // do the changes in the card type
    this.state = {
      direct_name_error: '',
    };
  }

  componentDidMount() {
    const that = this;
    const a = document.getElementById('checkout-modal');

    document.getElementById('checkout-modal').addEventListener('click', (e) => { if ((e.target === a) || (e.target === that.refs.close_btn)) { this.props.closeEvent(); lpApp.ops.checkout.resetCreditCardInformation(); }lpPattern.trackInPayment(P_CLOSE_PAIMENT); });
    // console.log("kkkk")
  }

  componentDidUpdate(prevProps) {
    if(document.getElementById('iban-element')) {
      this.iban.mount('#iban-element')

      var errorMessage = document.getElementById('error-message');
      var bankName = document.getElementById('bank-name');

      this.iban.on('change', function(event) {
        // Handle real-time validation errors from the iban Element.
        if (event.error) {
          errorMessage.textContent = event.error.message;
          errorMessage.classList.add('visible');
        } else {
          errorMessage.classList.remove('visible');
        }

        // Display bank name corresponding to IBAN, if available.
        if (event.bankName) {
          bankName.textContent = event.bankName;
          bankName.classList.add('visible');
        } else {
          bankName.classList.remove('visible');
        }
      });
    }


    if (!prevProps.show && this.props.show) {
      if (this.refs.credit_card_modal) {
        document.getElementById('checkout-modal').appendChild(this.refs.credit_card_modal);
        document.getElementById('checkout-modal').classList.add('lp-modal');
        document.getElementsByClassName('page-wrap')[0].style.filter = 'blur(5px)';
        document.body.style.overflow = 'hidden';
        lpApp.ops.utils.addModalClassToBody();
      }
    }
    if (prevProps.show && !this.props.show) {
      document.getElementById('checkout-modal').classList.remove('lp-modal');
      document.getElementsByClassName('page-wrap')[0].style.filter = 'none';
      document.body.style.overflow = 'auto';
      lpApp.ops.utils.removeModalClassToBody();
    }

    if (paypal && !document.querySelector('.paypal-buttons') && document.querySelector('#paypal-container')) {
      paypal.Buttons({
        style: {
          color: 'blue',
          fundingicons: 'false',
          layout: 'horizontal',
          tagline: 'false'
        },
        onClick: (data, actions)  => {
          if (!this.props.confirmation) {
            raiseError('credit-error', 20, _lp("Vous devez lire et accepter nos conditions générales de vente et d'utilisation."));
            return actions.reject()
          }
        },
        createOrder: (data, actions) => (actions.order.create({
          purchase_units: [{
            amount: {
              currency_code: 'EUR',
              value: this.totalPriceTTC().toFixed(2)
            }
          }]
        })),
        onApprove: (data, actions) => {
          return actions.order.capture().then((response) => {
            this.initiatePayment(data.orderID, response.payer.email_address)
          })
        },
      }).render('#paypal-container')
    }
  }

  componentWillUnmount() {
    if (document.getElementById('checkout-modal').firstChild) document.getElementById('checkout-modal').removeChild(document.getElementById('checkout-modal').firstChild);
    document.getElementById('checkout-modal').classList.remove('lp-modal');
    document.getElementsByClassName('page-wrap')[0].style.filter = 'none';
    document.body.style.overflow = 'auto';
    lpApp.ops.utils.removeModalClassToBody();
  }

  // TODO: better things.
  updateCardNumber(evt) {
    this.props.updateCardNumber(evt.target.value);
  }

  updateCardExpiration(evt) {
    this.props.dispatchUpdateCardExpiration(evt.target.value);
  }

  updateCardCCV(evt) {
    this.props.dispatchUpdateCardCCV(evt.target.value);
  }

  updateCheckBox(evt) {
    this.props.updateConfirmation(evt.target.checked);
  }

  updateName(evt){
    this.props.updateName_(evt.target.value);
  }

  // updateIban(evt){
  //     this.props.updateIban_(evt.target.value);
  // }

  choosePaymentMode(e) {
    const chosenMode = e.currentTarget.attributes['data-mode'].value;
    if (chosenMode === 'card') {
      this.props.setCard(true);
      this.props.set3X(false);
      this.props.setPaypal(false);
      this.props.setDirect(false);
      this.props.updatePaymentMethod(0);
      lpApp.ops.checkout.resetCheckedCondition();
    } else if (chosenMode === '3x') {
      this.props.setCard(false);
      this.props.set3X(true);
      this.props.setPaypal(false);
      this.props.setDirect(false);
      this.props.updatePaymentMethod(0);
      lpApp.ops.checkout.resetCheckedCondition();
    } else if(chosenMode == "direct") {
      this.props.setCard(false);
      this.props.set3X(false);
      this.props.setPaypal(false);
      this.props.setDirect(true);
      this.props.updatePaymentMethod(2);
      lpApp.ops.checkout.resetCheckedCondition();
    } else {
      this.props.setCard(false);
      this.props.set3X(false);
      this.props.setPaypal(true);
      this.props.setDirect(false);
      this.props.updatePaymentMethod(1);
      lpApp.ops.checkout.resetCheckedCondition();
    }

    initErrors();
  }

  selectPrice = () => {
    let selectedPrice;
    switch (this.props.selected_pack) {
      case 0:
        selectedPrice = 'first_price';
        break;
      case 1:
        selectedPrice = 'second_price';
        break;
      case 3:
        selectedPrice = 'fourth_price';
        break;
      default:
        selectedPrice = 'third_price';
        break;
    }
    return selectedPrice;
  }

  initiatePayment() {
    // if(this.props.confirmation){
    this.props.loading();
    initErrors();
    // pattern.
    lpPattern.trackLastAction(P_PAY);
    lpPattern.sendAndResetTracker();
    const selectedPrice = this.selectPrice()

    //---------------------============================= Credit Card
    if (this.props.payment_method === 0) { // credit card
      window.lp_payment.handleTransaction({
        type: 'card',
        card: {
          number: this.props.card_number,
          cvc: !this.props.card_ccv.includes(' ') ? this.props.card_ccv : this.props.card_ccv.slice(0, 3),
          exp: this.props.card_expiration,
        },
        contract_id: this.props.contract_id,
        pack: selectedPrice,
        invoice: {},
        coupon_code: this.props.promo_code,
        client_email: this.props.mail,
        pack_price: this.props.pack_price,
        document_name: lpApp.contractTitle,
        cgv: this.props.confirmation,
        is_installment: this.props.x3,
        is_crea_assist_sub: this.props.is_crea_assist_sub,
        price: this.totalPriceTTC(),
        paymentMethod: this.props.x3 ? 'stripe_x3' : 'stripe',
        upsell: this.props.upsell,
        revenue: this.totalRevenue(),
        orderShipping:this.props.fees,
        packPriceWithReduction: this.props.packPriceWithReduction,
        orderTax: this.props.totalTVA,
        acteProduct: false
      }).then((response) => {
        if (response.STATUS === 'SUCCESS') {
          window.localStorage.setItem('purchaseScore', response.purchaseScore);

          lpApp.setPayed(true)
          if (response.redirect !== undefined) {
            window.onbeforeunload = null;
            this.props.setReprise(true);
            this.props.setRepriseLink(response.redirect);
          }
          this.props.closeEvent();
        }
        this.props.unloading();
      }).catch(
        (error) => {
          try {
            const errorMessage = error && error.length && error[0].message
            lpevents.trackErrorPaymentCheckout(errorMessage)
          }
          catch(er) {
              console.log("error",er)
          }
          let err;
          if (error.gcv) {
            raiseError('credit-error', 12, error.gcv);
            err = error.ae;
          } else err = error;
          if (err.length && err.length > 0) {
            err.forEach((idx) => {
              if (idx.hook === 'global') raiseError('credit-error', 10, idx.message);
              else raiseError(idx.hook, 10, idx.message);
            });
          }
          // test if the thing is Error type
          if (err instanceof Error) {
            raiseError('credit-error', 12, err.message);
          }
          this.props.unloading();
        }
      )

    //-----------------============================= Direct Debit
    } else if(this.props.payment_method === 2) {

      //Test the name form
      if(this.props.direct_name.length == "") {
        this.setState({
          direct_name_error: "Veuillez saisir votre nom",
        })
        this.props.unloading();
        return
      }

      const valid_name = /^[a-zA-Z0-9_]{5,30}$/;
      if(valid_name.test(this.props.direct_name)) {
          this.setState({
            direct_name_error: "Le format de votre nom semble incorrect",
          })
          this.props.unloading();
          return
      }

      //Creat the token
      var sourceData = {
        type: 'sepa_debit',
        currency: 'eur',
        owner: {
          name: this.props.direct_name,
          email: this.props.mail,
        },
        mandate: {
          // Automatically send a mandate notification email to your customer
          // once the source is charged.
          notification_method: 'email',
        }
      };

      var that = this
      stripe.createSource(this.iban, sourceData).then((result) => {
        if (result.error) {
          // Inform the customer that there was an error.
          raiseError('credit-error', 12, result.error.message);

          this.props.unloading();
        } else {
          // Send the Source to your server to create a charge.

          // stripeSourceHandler(result.source);
          window.lp_payment.handleTransaction({
            type: 'sepa_debit',
            iban_source: result.source,
            contract_id: that.props.contract_id,
            pack: selectedPrice,
            options: [],
            invoic: {},
            coupon: that.props.promo_code,
            price: that.totalPriceTTC(),
            locale: 'fr_FR',
            client_email: that.props.mail,
            document_name: window.contractName,
            upsell: this.props.upsell,
            paymentMethod: 'sepa_debit',
            revenue: this.totalRevenue(),
            orderShipping:this.props.fees,
            packPriceWithReduction: this.props.packPriceWithReduction,
            orderTax: this.props.totalTVA,
            acteProduct: false
          }).then((response) => {
            if (response.STATUS === 'SUCCESS') {
              window.localStorage.setItem('purchaseScore', response.purchaseScore);
              lpApp.setPayed(true)
              if (response.redirect !== undefined) {
                window.onbeforeunload = null;
                that.props.setReprise(true);
                that.props.setRepriseLink(response.redirect);
              }
              that.props.closeEvent();
            }
            that.props.unloading();
          }).catch((error) => {
            try {
              
              const errorMessage = error && error.length && error[0].message
              lpevents.trackErrorPaymentCheckout(errorMessage)
            }
            catch(er) {
                console.log("error",er)
            }
            let err = [];

            if (err.length && err.length > 0) {
              err.forEach((idx) => {
                if (idx.hook === 'global') raiseError('credit-error', 10, idx.message);
                else raiseError(idx.hook, 10, idx.message);
              });
            }
            // test if the thing is Error type

            if (err instanceof Error) {
              raiseError('credit-error', 12, err.message);
            }
            that.props.unloading();
          });


        }
      });

      //send it to the backend


    //-----------------============================= Paypal
    } else {
      if (!this.props.confirmation) {
        raiseError('credit-error', 20, _lp("Vous devez lire et accepter nos conditions générales de vente et d'utilisation."));
        this.props.unloading();
        return;
      }

      const pack = this.selectPrice();


      window.lp_payment.handleTransaction({
        type: 'paypal',
        contract_id: this.props.contract_id,
        pack,
        options: [],
        invoice: {},
        pack_price: this.props.pack_price,
        coupon: this.props.promo_code,
        price: this.totalPriceTTC().toFixed(2),
        locale: 'fr_FR',
        client_email: this.props.mail,
        document_name: window.contractName,
        cgv: this.props.confirmation,
        upsell: this.props.upsell,
        paymentMethod: 'paypal',
        revenue: this.totalRevenue(),
        orderShipping:this.props.fees,
        packPriceWithReduction: this.props.packPriceWithReduction,
        orderTax: this.props.totalTVA,
        acteProduct:  false
      }).then((response) => {
        if (response.STATUS === 'SUCCESS') {
          lpApp.setPayed(true)
          window.localStorage.setItem('purchaseScore', response.purchaseScore);

          if (response.redirect !== undefined) {
            window.onbeforeunload = null;
            this.props.setReprise(true);
            this.props.setRepriseLink(response.redirect);
          }
          this.props.closeEvent();
        }
        this.props.unloading();
      }).catch((error) => {
        try {
          const errorMessage = error && error.length && error[0].message
          lpevents.trackErrorPaymentCheckout(errorMessage)
        }
        catch(er) {
            console.log("error",er)
        }
        let err;
        if (error.gcv) {
          raiseError('credit-error', 12, error.gcv);
          err = error.ae;
        } else err = error;
        if (err.length && err.length > 0) {
          err.forEach((idx) => {
            if (idx.hook === 'global') raiseError('credit-error', 10, idx.message);
            else raiseError(idx.hook, 10, idx.message);
          });
        }
        // test if the thing is Error type
        if (err instanceof Error) {
          raiseError('credit-error', 12, err.message);
        }
        this.props.unloading();
      });
    }

    const pack = this.selectPrice();


    const eventParams = {};
    eventParams['Chosen price'] = this.props.price[pack];
    eventParams['Total price'] = this.totalPriceTTC();
    eventParams['Chosen pack'] = pack;
    eventParams['Payment method'] = this.props.payment_method === 0 ? 'Stripe' : 'Paypal';
    lpevents.track('Asked Payment', eventParams);
    lpevents.trackClickPayment()

  }

  totalPriceTTC() {
    if (this.props.totalTTC)
    return parseFloat(this.props.totalTTC)

    let thePrice = this.props.pack_price;

    // In case of reduction we show it
    if (this.props.promo_percentage && parseFloat(this.props.promo_percentage) > 0) {
      thePrice -= (thePrice * this.props.promo_percentage);
    }

    // Calculating cart prices
    const legalAnnonce = this.props.pack_fees >= 195 ? 195 : 0;
    const totalHT = (thePrice + (this.props.pack_fees || 0));
    const totalTVA = (((thePrice * 1.2) - thePrice) + ((legalAnnonce * 1.2) - legalAnnonce));
    window.xPcsiUD7J = (parseFloat(totalHT) + parseFloat(totalTVA));
    return (parseFloat(totalHT) + parseFloat(totalTVA));
  }

  totalRevenue() {
    let thePrice = this.props.pack_price;

    // In case of reduction we show it
    if (this.props.promo_percentage && parseFloat(this.props.promo_percentage) > 0) {
      thePrice -= (thePrice * this.props.promo_percentage);
    }
    // Calculating cart prices
    let legalAnnonceRevenue = this.props.pack_fees >= 195 ? 75 : 0;

    return thePrice + legalAnnonceRevenue
  }

  render() {
    const cgvLink = Object.keys(CUSTOM_CGV_LINK_PER_META_IDS).indexOf(`${lpApp.contractMetaId}`) > -1
      ? CUSTOM_CGV_LINK_PER_META_IDS[lpApp.contractMetaId]
      : 'https://www.legalplace.fr/conditions-generales/'

    return (
      <div ref="credit_card_modal" className="lpm-container">
        {this.props.show
          && (
          <div>
            <div ref="close_btn" className="lpm-close icn-x" />
            <div className="lpm-content">
              <div className="checkout-payement">
                <h2 className="cp-title">Choisissez votre moyen de paiement</h2>
                <div className="tabs">
                  <div className="tab-nav">
                    <a data-mode="card" style={linkStyle} onClick={this.choosePaymentMode} className={`tn-btn${(this.props.card) ? ' active' : ''}`}>
                      <div className="pc-tab-radio" />
                      <span className="tnb-text">&nbsp; Carte bancaire</span>
                    </a>
                    {this.props.allow3xPayment && (<a data-mode="3x" style={linkStyle} onClick={this.choosePaymentMode} className={`tn-btn${(this.props.x3) ? ' active' : ''}`}>
                      <div className="pc-tab-radio" />
                      <span className="tnb-text">&nbsp;
CB en
                        {' '}
                        <strong>3 fois</strong>
                      </span>
                    </a>)}
                    {(!this.props.is_crea_assist_sub)
                      ? (
                        <a data-mode="paypal" style={linkStyle} onClick={this.choosePaymentMode} className={`tn-btn${(this.props.paypal) ? ' active' : ''}`}>
                          <div className="pc-tab-radio" />
                          <span className="tnb-text">&nbsp;
                            {' '}
                            <strong>PayPal</strong>
                          </span>
                        </a>
                      )
                      : ''}
                      <a  data-mode="direct" style={linkStyle} onClick={this.choosePaymentMode} className={`tn-btn${(this.props.direct) ? ' active' : ''}`}>
                          <div className="pc-tab-radio"></div>
                          <span className="tnb-text">&nbsp;{' '}<span>Prélèvement</span></span>
                      </a>
                  </div>
                  {/* <!-- Tab --> */}
                  <div className="tab">


                    <div style={(this.props.card) ? divStyle.block : divStyle.none} className="tab-content cb-payement one-payement">
                      <div className="form-payement">
                        {this.props.credit_error
                                      && (
                                      <div className="alert error">
                                        <span>
                                          {' '}
                                          {this.props.credit_error.message}
                                          {' '}
                                        </span>
                                      </div>
                                      )}
                        <div className={`form-group form-payement__card-number${this.props.error_card ? ' error' : ''}`}>
                          <div className="fg-wrapper" cypress-id="cc-number-1time">
                            <label>Numéro de la carte</label>
                            <MaskedInput mask="!!!! !!!! !!!! !!!!" type="text" className="form-control" autoComplete="cc-number" value={this.props.card_number} onChange={this.updateCardNumber} />
                            {this.props.error_card && (
                            <span className="help-block">
                              {' '}
                              { this.props.error_card.message }
                              {' '}
                            </span>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className={`form-group col-sm-6 form-payement__exp-date${this.props.error_exp ? ' error' : ''}`}>
                            <div className="fg-wrapper">
                              <label>Date d'expiration</label>
                              <MaskedInput mask="!!/!!" placeholder="MM - AA" type="text" className="form-control" autoComplete="cc-exp" value={this.props.card_expiration} onChange={this.updateCardExpiration} />
                              {this.props.error_exp && (
                              <span className="help-block">
                                {' '}
                                { this.props.error_exp.message }
                                {' '}
                              </span>
                              )}
                            </div>
                          </div>
                          <div className={`form-group col-sm-6 form-payement__cv${this.props.error_cvc ? ' error' : ''}`}>
                            <div className="fg-wrapper">
                              <label>Cryptogramme visuel</label>
                              <div className="wz-helper on-top">
                                <div className="wzh-wrap">
                                  <img width="95" src="/wizard/img/icn-crypto-w.svg" />
                                  {/* eslint-disable-next-line */}
                                  <span>Les trois derniers chiffres imprimés au dos de votre carte de crédit</span>
                                </div>
                              </div>

                              <MaskedInput mask="!!!!" type="text" className="form-control" autoComplete="cc-csc" value={this.props.card_ccv} onChange={this.updateCardCCV} />
                              {this.props.error_cvc && (
                              <span className="help-block">
                                {' '}
                                { this.props.error_cvc.message }
                                {' '}
                              </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="payement-footer">
                          <div className="row">
                            <div className="col-sm-6 cp-conditions">
                              <div className="lp-chbx">
                                <input type="checkbox" id="check1" value={this.props.confirmation} onClick={this.updateCheckBox} />
                                <label htmlFor="check1">
                                  <span className="chbx-txt">
                                    En cochant cette case, j'accepte les
                                    {' '}
                                    <a target="_blank" rel="noopener noreferrer" href={cgvLink}>
                                    conditions générales
                                    </a>

                                    {/* Conditions d'abonnement pour le pack Assistance */}
                                    {(this.props.is_crea_assist_sub) ? ' et les ' : ''}
                                    {(this.props.is_crea_assist_sub) ? <a target="_blank" rel="noopener noreferrer" href="https://www.legalplace.fr/conditions-generales-abonnement/">
                                    conditions générales d'abonnement
                                    </a>: '' }
                                  </span>
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <a className={`xcta cta-payement has-spinner${this.props.loading_payment ? ' is-checking' : ''}`} href="javascript:void(0)" onClick={this.props.loading_payment ? () => {} : this.initiatePayment}>
                                <i className="icn-checkmark" />
                                <span className="btn-text">
                                  Payer
                                  {' '}
                                  {this.totalPriceTTC().toFixed(2).toString().replace('.',',')}
                                  {' '}
                                  €
                                </span>
                              </a>
                              <span className="secure-payement">
                                <i className="icn-lock" />
                                                      Paiement sécurisé
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div style={(this.props.x3) ? divStyle.block : divStyle.none} className="tab-content cb-payement three-payement">
                      <div className="form-payement">
                        {this.props.credit_error
                          && (
                          <div className="alert error">
                            <span>
                              {' '}
                              {this.props.credit_error.message}
                              {' '}
                            </span>
                          </div>
                          )}
                        <div className={`form-group form-payement__card-number${this.props.error_card ? ' error' : ''}`}>
                          <div className="fg-wrapper">
                            <label>Numéro de la carte</label>
                            <MaskedInput mask="!!!! !!!! !!!! !!!!" type="text" className="form-control" autoComplete="cc-number" value={this.props.card_number} onChange={this.updateCardNumber} />
                            {this.props.error_card && (
                            <span className="help-block">
                              {' '}
                              { this.props.error_card.message }
                              {' '}
                            </span>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className={`form-group col-sm-6 form-payement__exp-date${this.props.error_exp ? ' error' : ''}`}>
                            <div className="fg-wrapper">
                              <label>Date d'expiration</label>
                              <MaskedInput mask="!!/!!" placeholder="MM - AA" type="text" className="form-control" autoComplete="cc-exp" value={this.props.card_expiration} onChange={this.updateCardExpiration} />
                              {this.props.error_exp && (
                              <span className="help-block">
                                {' '}
                                { this.props.error_exp.message }
                                {' '}
                              </span>
                              )}
                            </div>
                          </div>
                          <div className={`form-group col-sm-6 form-payement__cv${this.props.error_cvc ? ' error' : ''}`}>
                            <div className="fg-wrapper">
                              <label>Cryptogramme visuel</label>
                              <div className="wz-helper on-top">
                                <div className="wzh-wrap">
                                  <img width="95" src="/wizard/img/icn-crypto-w.svg" />
                                  {/* eslint-disable-next-line */}
                                  <span>Les trois derniers chiffres imprimés au dos de votre carte de crédit</span>
                                </div>
                              </div>

                              <MaskedInput mask="!!!!" type="text" className="form-control" autoComplete="cc-csc" value={this.props.card_ccv} onChange={this.updateCardCCV} />
                              {this.props.error_cvc && (
                              <span className="help-block">
                                {' '}
                                { this.props.error_cvc.message }
                                {' '}
                              </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="payement-footer">
                          <div className="row">
                            <div className="col-sm-6 cp-conditions">
                              <div className="lp-chbx">
                                <input type="checkbox" id="check3" value={this.props.confirmation} onClick={this.updateCheckBox} />
                                <label htmlFor="check3">
                                  <span className="chbx-txt">
                                    En cochant cette case, j'accepte les
                                    {' '}
                                    <a target="_blank" rel="noopener noreferrer" href={cgvLink}>
                                    conditions générales
                                    </a>

                                    {/* Conditions d'abonnement pour le pack Assistance */}
                                    {(this.props.is_crea_assist_sub) ? ' et les ' : ''}
                                    {(this.props.is_crea_assist_sub) ? <a target="_blank" rel="noopener noreferrer" href="https://www.legalplace.fr/conditions-generales-abonnement/">
                                    conditions générales d'abonnement
                                    </a>: '' }
                                  </span>
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <a className={`xcta cta-payement has-spinner${this.props.loading_payment ? ' is-checking' : ''}`} onClick={this.props.loading_payment && this.state.payment_loading ? () => {} : () => this.initiatePayment()}>
                                <i className="icn-checkmark" />
                                {this.props.loading_payment ? <img width="24" src="/wizard/img/lp-spinner.svg" /> : ''}
                                <span className="btn-text">
                                  Payer {' '}
                                  {(this.totalPriceTTC() / 3).toFixed(2).toString().replace('.',',') }
                                  {' '}
                                  €
                                </span>
                              </a>
                              <span className="secure-payement">
                                <i className="icn-lock" />
                                                      Paiement sécurisé
                              </span>
                            </div>
                          </div>
                          <div className="cp-infos">
                                              Trois mensualités de
                            {' '}
                            <strong>
                              {(this.totalPriceTTC() / 3).toFixed(2).toString().replace('.',',')}
                              {' '}
€
                            </strong>
, sans frais supplémentaires.
                          </div>
                        </div>
                      </div>
                    </div>


                    {(!this.props.is_crea_assist_sub)
                      ? (
                        <div style={(this.props.paypal) ? divStyle.block : divStyle.none} className="tab-content paypal-payement">
                          <div className="form-payement">
                            {this.props.credit_error
                                      && (
                                      <div className="alert error">
                                        <span>
                                          {' '}
                                          {this.props.credit_error.message}
                                          {' '}
                                        </span>
                                      </div>
                                      )}
                            <div className="payement-footer">
                              <div className="lp-chbx">
                                <input type="checkbox" id="check2" value={this.props.confirmation} onClick={this.updateCheckBox} />
                                <label htmlFor="check2">
                                  <span className="chbx-txt">
                                    En cochant cette case, j'accepte les
                                    {' '}
                                    <a target="_blank" rel="noopener noreferrer" href={cgvLink}>
                                    conditions générales
                                    </a>

                                    {/* Conditions d'abonnement pour le pack Assistance */}
                                    {(this.props.is_crea_assist_sub) ? ' et les ' : ''}
                                    {(this.props.is_crea_assist_sub) ? <a target="_blank" rel="noopener noreferrer" href="https://www.legalplace.fr/conditions-generales-abonnement/">
                                    conditions générales d'abonnement
                                    </a>: '' }
                                  </span>
                                </label>
                              </div>
                              <div id='paypal-container' className='paypal-crea-button'></div>
                            </div>
                          </div>
                        </div>
                      ) : '' }

                      <div style={(this.props.direct == true) ? divStyle.block : divStyle.none} className="tab-content prelevement-payement" >
                          <div className="form-payement">
                          {this.props.credit_error
                                && (
                                <div className="alert error">
                                  <span>
                                    {' '}
                                    {this.props.credit_error.message}
                                    {' '}
                                  </span>
                                </div>
                                )}
                              <div className={`form-group form-payement__name"${this.state.direct_name_error ? ' error' : ''}`}>
                                  <div className="fg-wrapper">
                                      <label>Nom et prénom</label>
                                      <input type="text" className="form-control" value={this.props.direct_name} onChange={this.updateName} />
                                      {this.state.direct_name_error && (
                                        <span className="help-block">
                                          {' '}
                                          { this.state.direct_name_error }
                                          {' '}
                                        </span>
                                        )}
                                  </div>
                              </div>
                              <div className="form-group form-payement__iban">
                                  <div className="fg-wrapper">
                                      <label>IBAN</label>
                                      <div className="fc-wrapper" id="iban-element" />
                                      <div id="bank-name" />
                                      <div id="error-message" role="alert" />
                                  </div>
                              </div>
                              <div className="payement-footer">
                                  <a className={`--has-spinner cta-payement${this.props.loading_payment ? ' --is-checking' : ''}`}  onClick={this.props.loading_payment ? () => {} : this.initiatePayment}>
                                    <i className="icn-checkmark" />
                                    <span className="btn-text">
                                      Payer
                                      {' '}
                                      {this.totalPriceTTC().toFixed(2).toString().replace('.',',')}
                                      {' '}
                                      €
                                    </span>
                                  </a>
                                  <p className="iban-text">
                                      En fournissant votre IBAN et en confirmant ce paiement, vous autorisez legalplace.fr et
                                      Stripe, notre prestataire de services de paiement, à envoyer des instructions à votre
                                      banque pour débiter votre compte conformément à ces instructions. Vous avez droit à un
                                      remboursement de votre banque selon les termes et conditions de votre accord avec votre
                                      banque. Un remboursement doit être réclamé dans un délai de 8 semaines à compter de la
                                      date à laquelle votre compte a été débité.
                                  </p>
                              </div>
                          </div>
                      </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let packPrice;
  let packFees;

  switch (state.checkout_operations.pack) {
    case 0:
      packPrice = state.checkout_operations.prices.first_price;
      packFees = state.checkout_operations.admin_fees.first_price;
      break;
    case 1:
      packPrice = state.checkout_operations.prices.second_price;
      packFees = state.checkout_operations.admin_fees.second_price;
      break;
    case 3:
      packPrice = state.checkout_operations.prices.fourth_price;
      packFees = state.checkout_operations.admin_fees.fourth_price;
      break;
    default:
      packPrice = state.checkout_operations.prices.third_price;
      packFees = state.checkout_operations.admin_fees.third_price;
  }

  return {
    payment_method: state.checkout_operations.payment_method,
    card_number: state.checkout_operations.credit_card.number,
    card_expiration: state.checkout_operations.credit_card.expiration,
    card_ccv: state.checkout_operations.credit_card.ccv,
    direct_name: state.checkout_operations.direct_name,
    direct_iban: state.checkout_operations.direct_iban,
    contract_id: state.checkout_operations.contract_id,
    selected_pack: state.checkout_operations.pack,
    price: state.checkout_operations.prices,
    call_chosen: state.checkout_operations.has_call,
    letter_chosen: state.checkout_operations.has_letter,
    // now with the letter informayion
    letter_number: state.checkout_operations.letter.number,
    letter_zip: state.checkout_operations.letter.zip,
    letter_city: state.checkout_operations.letter.city,
    letter_address: state.checkout_operations.letter.address,
    letter_name: state.checkout_operations.letter.name,
    // coupone code
    promo_code: state.checkout_operations.promo_code,
    confirmation: state.checkout_operations.confirm,
    promo_percentage: state.checkout_operations.promo_percentage,
    pack_price: packPrice,
    pack_fees: packFees,
    // the errors are here
    credit_error: state.errors.components['credit-error'],
    error_card: state.errors.components['card.number'],
    error_exp: state.errors.components['card.exp'],
    error_cvc: state.errors.components['card.cvc'],
    error_direct_name: state.errors.components['direct.name'],
    error_direct_iban: state.errors.components['direct.iban'],
    // payment loading
    loading_payment: state.loading_details.checking_payment,
    // For payment add
    mail: state.account_settings.mail,
    card: state.account_settings.card,
    x3: state.account_settings.x3,
    paypal: state.account_settings.paypal,
    direct: state.account_settings.direct,
    is_crea_assist_sub: state.account_settings.is_crea_assist_sub,
  };
};


const mapDispatchToProps = (dispatch) => {
  const l = store.getState().document_state.state;
  if (l === 'new') {
    // dispatch({type: SET_DOCUMENT_ID, doc: d})
  }
  return {
    updatePaymentMethod: (meth) => {
      dispatch(ckPaymentSelect(meth));
    },
    updateCardNumber: (val) => {
      dispatch(ckCUpdateCardNumber(val));
    },
    dispatchUpdateCardExpiration: (val) => {
      dispatch(ckCUpdateCardExpiration(val));
    },
    dispatchUpdateCardCCV: (val) => {
      dispatch(ckCUpdateCCV(val));
    },
    updateName_: (val) => {
      dispatch(ckCUpdateDirectName(val));
    },
    updateIban_: (val) => {
        dispatch(ckCUpdateIban(val));
    },
    updateConfirmation: (val) => {
      dispatch({ type: CK_CHECK, val });
    },
    loading: () => {
      dispatch(checkingPayment(true));
    },
    unloading: () => {
      dispatch(checkingPayment(false));
    },
    setRepriseLink: (val) => {
      dispatch(setRepriseLink(val));
    },
    setReprise: (val) => {
      dispatch(setRepriseWizard(val));
    },
    setCard: (val) => {
      dispatch(setCardPayment(val));
    },
    set3X: (val) => {
      dispatch(setX3Payment(val));
    },
    setPaypal: (val) => {
      dispatch(setPaypalPayment(val));
    },
    setDirect: (val)=>{
        dispatch(setDirectPayment(val));
    },
  };
};

const CardModalNext = connect(mapStateToProps, mapDispatchToProps)(_CardModalNext);

export default CardModalNext;



// WEBPACK FOOTER //
// ./src/components/buy/card-modal-next.js